import Widget             from "lib/widget";
import AjaxForm           from "servos/ajaxForm";

class Share extends Widget {
  bind() {
    bindProjectForm.call(this);
    bindAccountForm.call(this);
    bindEmailCouncil.call(this);
    bindEmailNoticeOfIntention.call(this);
    bindEmailRfsPlans.call(this);
    bindChecklistForms.call(this);
  }
}

let bindProjectForm = function() {
  this.projectFormElem = this.root.find('#share-modal #share-project')
  this.ajaxForm = new AjaxForm(this.projectFormElem)
  this.ajaxForm.on("success",  success.bind(this))
  this.ajaxForm.on("error",    projectError.bind(this))
}

let projectError = function(response) {
  this.projectFormElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindProjectForm.call(this);
}



let bindAccountForm = function() {
  this.accountFormElem = this.root.find('#share-modal #share-account')
  this.ajaxForm = new AjaxForm(this.accountFormElem)
  this.ajaxForm.on("success",  success.bind(this))
  this.ajaxForm.on("error",    accountError.bind(this))
}


let accountError = function(response) {
  this.accountFormElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindAccountForm.call(this);
}

let bindEmailCouncil = function() {
  this.emailCouncilFromElem = this.root.find('#email-council-modal #email-noc-to-council')
  this.ajaxForm = new AjaxForm(this.emailCouncilFromElem)
  this.ajaxForm.on("success",  emailCouncilSuccess.bind(this))
  this.ajaxForm.on("error",    emailCouncilError.bind(this))
}

let emailCouncilSuccess = function() {
  const statusUrl = this.emailCouncilFromElem.data('noc-status-url')
  this.root.find('#email-council-modal').modal('hide')
  swal({ title: "Sent", type: 'success', showConfirmButton: false, timer: 3000 })
  if (statusUrl) {
    pollNocSentStatus.call(this, statusUrl)
  }
}

let pollNocSentStatus = function(statusUrl) {
  const $button = this.root.find('button[data-bs-target="#email-council-modal"]')
  const $spinner = $('<span>').addClass('spinner-border spinner-border-sm ms-1').attr('role', 'status')
  $button.append($spinner)

  const poll = setInterval(() => {
    $.getJSON(statusUrl, (data) => {
      if (data.sent_at) {
        clearInterval(poll)
        $spinner.remove()
        if ($button.find('.bi-check-circle-fill').length === 0) {
          const $icon = $('<span>')
            .addClass('bi bi-check-circle-fill ms-1')
            .attr('data-bs-toggle', 'tooltip')
            .attr('data-bs-placement', 'top')
            .attr('data-bs-title', `Email sent at ${data.sent_at}`)
          $button.append($icon)
          new bootstrap.Tooltip($icon[0])
        }
      }
    })
  }, 10000)
}

let emailCouncilError = function(response) {
  this.emailCouncilFromElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindEmailCouncil.call(this);
}

let bindEmailNoticeOfIntention = function() {
  this.emailNoticeOfIntentionFromElem = this.root.find('#email-notice-of-intention-modal #email-notice-of-intention')
  this.ajaxForm = new AjaxForm(this.emailNoticeOfIntentionFromElem)
  this.ajaxForm.on("success",  success.bind(this))
  this.ajaxForm.on("error",    emailNoticeOfIntentionError.bind(this))
}

let emailNoticeOfIntentionError = function(response) {
  this.emailNoticeOfIntentionFromElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindEmailNoticeOfIntention.call(this);
}

let bindEmailRfsPlans = function() {
  this.emailRfsPlansFormElem = this.root.find('#email-rfs-modal #email-rfs-plans')
  this.ajaxForm = new AjaxForm(this.emailRfsPlansFormElem)
  this.ajaxForm.on("success",  emailRfsPlansSuccess.bind(this))
  this.ajaxForm.on("error",    emailRfsPlansError.bind(this))

  this.root.find('#email-rfs-modal').on('show.bs.modal', (e) => {
    this._emailRfsTriggerBtn = $(e.relatedTarget)
  })
}

let emailRfsPlansSuccess = function() {
  const statusUrl = this.emailRfsPlansFormElem.data('rfs-status-url')
  this.root.find('#email-rfs-modal').modal('hide')
  swal({ title: "Sent", type: 'success', showConfirmButton: false, timer: 3000 })
  if (statusUrl && this._emailRfsTriggerBtn) {
    pollRfsSentStatus.call(this, statusUrl, this._emailRfsTriggerBtn)
  }
}

let pollRfsSentStatus = function(statusUrl, $triggerBtn) {
  const $spinner = $('<span>').addClass('spinner-border spinner-border-sm ms-1').attr('role', 'status')
  $triggerBtn.append($spinner)

  const poll = setInterval(() => {
    $.getJSON(statusUrl, (data) => {
      if (data.sent_at) {
        clearInterval(poll)
        $spinner.remove()
        const $icon = $triggerBtn.find('.js-email-rfs-sent')
        $icon.attr('data-bs-toggle', 'tooltip')
             .attr('data-bs-placement', 'top')
             .attr('data-bs-title', `Email sent at ${data.sent_at}`)
             .removeClass('d-none')
        new bootstrap.Tooltip($icon[0])
      }
    })
  }, 10000)
}

let emailRfsPlansError = function(response) {
  this.emailRfsPlansFormElem.replaceWith(response.jqXHR.responseJSON.formHtml);
  bindEmailRfsPlans.call(this);
}

let bindChecklistForms = function() {
  this.root.find('.share-checklist-form').each((_, formEl) => {
    const $form = $(formEl)
    const checklistId = $form.find('input[name="checklist_id"]').val()
    const ajaxForm = new AjaxForm($form)
    ajaxForm.on("success", () => {
      this.root.find(`#share-checklist-modal-${checklistId}`).modal('hide')
      swal({ title: "Sent", type: 'success', showConfirmButton: false })
    })
    ajaxForm.on("error", (response) => {
      $form.replaceWith(response.jqXHR.responseJSON.formHtml)
      bindChecklistForms.call(this)
    })
  })
}

// common
let success = function(response) {
  this.root.find('#share-modal').modal('hide');
  swal({
    title: "Sent",
    type: 'success',
    showConfirmButton: false
  })
}




export default Share
